@if (forzaLink()) {
  <div class="button-container">
    <a href="{{ forzaLink() }}" odxLink i18n="@@newProject.projectForm.buttonLabel.forzaLink" target="_blank">
      <odx-icon name="link-external" inline />
      Zum FORZA-Projekt
    </a>
  </div>
}
